module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "pa-5"
  }, [_c('v-btn', {
    staticClass: "close-btn",
    attrs: {
      "fab": "",
      "small": "",
      "flat": "",
      "absolute": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("x")]), _vm._v(" "), (_vm.validationInfo.errors) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "py-2": ""
    }
  }, _vm._l((_vm.validationInfo.errors), function(err, index) {
    return _c('v-alert', {
      key: index,
      attrs: {
        "value": true,
        "type": "error"
      }
    }, [_vm._v(_vm._s(err))])
  }), 1) : _vm._e(), (_vm.validationInfo.warnings) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "py-2": ""
    }
  }, _vm._l((_vm.validationInfo.warnings), function(warning, index) {
    return _c('v-alert', {
      key: index,
      attrs: {
        "value": true,
        "type": "warning"
      }
    }, [_vm._v(_vm._s(warning))])
  }), 1) : _vm._e(), (_vm.validationInfo.infos) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "py-2": ""
    }
  }, _vm._l((_vm.validationInfo.infos), function(info, index) {
    return _c('v-alert', {
      key: index,
      attrs: {
        "value": true,
        "type": "success"
      }
    }, [_vm._v(_vm._s(info))])
  }), 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7e633720","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/Validate.vue
// module id = 589
// module chunks = 13